import React from "react";

interface TreeProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?: string;
}

const Tree: React.FC<TreeProps> = ({
  size = 24,
  className,
  onClick,
  color = "#F7F9F9",
}) => {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M10 3.3302V14.5302C10 16.2104 10 17.0504 10.327 17.6922C10.6146 18.2567 11.0735 18.7156 11.638 19.0032C12.2798 19.3302 13.1198 19.3302 14.8 19.3302H15M15 19.3302C15 20.4348 15.8954 21.3302 17 21.3302C18.1046 21.3302 19 20.4348 19 19.3302C19 18.2256 18.1046 17.3302 17 17.3302C15.8954 17.3302 15 18.2256 15 19.3302ZM5 3.3302L15 3.3302M5 3.3302C5 4.43477 4.10457 5.3302 3 5.3302C1.89543 5.3302 1 4.43477 1 3.3302C1 2.22563 1.89543 1.3302 3 1.3302C4.10457 1.3302 5 2.22563 5 3.3302ZM15 3.3302C15 4.43477 15.8954 5.3302 17 5.3302C18.1046 5.3302 19 4.43477 19 3.3302C19 2.22563 18.1046 1.3302 17 1.3302C15.8954 1.3302 15 2.22563 15 3.3302ZM10 11.3302H15M15 11.3302C15 12.4348 15.8954 13.3302 17 13.3302C18.1046 13.3302 19 12.4348 19 11.3302C19 10.2256 18.1046 9.3302 17 9.3302C15.8954 9.3302 15 10.2256 15 11.3302Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Tree;
